/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Fragment } from 'react';

import { track } from '@coursera/event-pulse/sdk';

import MobileButton from 'bundles/composable-page-header/components/mobile-menu-items/MobileButton';
import { MOBILE_MAIN_IDENTIFIER } from 'bundles/composable-page-header/constants';
import { useMobileToSubPage } from 'bundles/composable-page-header/contexts/MobileNavigationContext';

import _t from 'i18n!nls/composable-page-header';

const styles = {
  exploreButton: css`
    margin-top: var(--cds-spacing-100);
  `,
  lastInSection: css`
    padding-top: var(--cds-spacing-100);
    padding-bottom: var(--cds-spacing-100);
  `,
};

const getButtons = () => [
  {
    label: _t('Explore roles'),
    id: MOBILE_MAIN_IDENTIFIER.EXPLORE_ROLES_MENU,
  },
  {
    label: _t('Explore categories'),
    id: MOBILE_MAIN_IDENTIFIER.EXPLORE_CATEGORIES_MENU,
  },
  {
    label: _t('Trending skills'),
    id: MOBILE_MAIN_IDENTIFIER.EXPLORE_SKILLS_MENU,
  },
  {
    label: _t('Earn a professional certificate'),
    id: MOBILE_MAIN_IDENTIFIER.EARN_PROFESSIONAL_CERTIFICATE_MENU,
  },
  {
    label: _t('Earn an online degree'),
    id: MOBILE_MAIN_IDENTIFIER.EARN_ONLINE_DEGREE_MENU,
  },
];

const ExploreMenuItems = () => {
  const toSubPage = useMobileToSubPage();

  return (
    <Fragment>
      {getButtons().map(({ id, label }, index) => (
        <MobileButton
          key={id}
          css={index === 0 ? styles.exploreButton : undefined}
          label={label}
          name={id}
          ariaLabel={label}
          trackingName={id}
          onButtonClick={() => {
            track('view_megamenu_items', {
              megamenuItemName: id,
              megamenuSection: id,
            });
            toSubPage?.(id);
          }}
        />
      ))}
      <MobileButton
        css={styles.lastInSection}
        label={_t('Prepare for a certification exam')}
        href="/explore/certification-preparation-courses"
        name="prepareForCertificationExam"
        trackingName="prepare_for_certification_exam"
        onButtonClick={() => {
          track('click_megamenu_item', {
            megamenuItemLink: '/explore/certification-preparation-courses',
            megamenuItemName: 'prepare-for-certification-exam',
            megamenuSection: 'mobile',
            megamenuItemType: 'other',
          });
        }}
      />
    </Fragment>
  );
};

export default ExploreMenuItems;
